angular.module('SpidApp').factory('ServiceFactory', ['$injector', 'Restangular', function ($injector, Restangular) {
    var ServiceFactory = function (params) {
        params = params || {}

        var baseRoute = params.baseRoute
        var modelName = params.modelName

        if (!baseRoute || !modelName) {
            throw 'ServiceFactory() - Missing parameters'
        }

        var Service = {
            /*
                We wrapped this in a closure because the Model should be a constant :)
            */
            all: (function () {
                /*
                    Since this part is dynamicly generated, we couldn't just inject the Model
                    So we are asking the injector directly
                */
                var Model = $injector.get(modelName)
                return function () {
                    return Restangular.all(baseRoute).getList().then(function (datas) {
                        return _.map(datas, function (data) {
                            return new Model(data)
                        })
                    })
                }
            })()
        }

        return Service
    }

    return ServiceFactory
}])

var metaModels = [
      { modelName: 'Affranchissement'                            , attributes: ['code_affranchissement', 'lib_court', 'lib_long', 'commentaire', 'is_available', 'type_reference', 'template_impression', 'updated_at', 'deleted_at'] }
    , { modelName: 'ChoixOptionAffranchissementDestination'      , attributes: ['code', 'type_option', 'code_destination', 'code_affranchissement', 'lib_long', 'is_default', 'updated_at'] }
    , { modelName: 'ComplementServiceAffranchissementDestination', attributes: ['code', 'code_service', 'code_destination', 'code_affranchissement', 'updated_at'] }
    , { modelName: 'Destination'                                 , attributes: ['id_pays', 'code_destination', 'label', 'updated_at', 'deleted_at'] }
    , { modelName: 'DestinationZone'                             , attributes: ['code_destination','id_zone','updated_at','deleted_at'] }
    , { modelName: 'OptionAffranchissementDestination'           , attributes: ['type_option', 'code_destination', 'code_affranchissement', 'lib_long', 'is_mandatory', 'updated_at'] }
    , { modelName: 'PrixServiceAffranchissementDestination'      , attributes: ['code_service_speciaux', 'code_acheminement', 'code_affranchissement', 'code_destination', 'unite', 'tranche_inferieure', 'tranche_superieure', 'prix', 'updated_at','impression'] }
    , { modelName: 'PrixTrancheAffranchissementZone'             , attributes: ['code_affranchissement', 'id_zone', 'tranche_inferieure', 'tranche_superieure', 'prix', 'updated_at'] }
    , { modelName: 'Restriction'                                 , attributes: ['code_destination', 'code_affranchissement', 'code', 'label', 'updated_at', 'deleted_at'] }
    , { modelName: 'ServiceAffranchissementDestination'          , attributes: ['code_service', 'code_acheminement', 'code_affranchissement', 'code_destination', 'mandatory', 'isUse', 'lib_long', 'lib_court', 'updated_at', 'deleted_at'] }
    , { modelName: 'ZoneAffranchissement'                        , attributes: ['id_zone', 'code_affranchissement', 'prix_complementaire', 'poids_complementaire', 'updated_at', 'deleted_at', 'seuil'] }
]

metaModels.forEach(function (meta) {
    if (  !meta || !meta.modelName || !meta.attributes) {
        throw 'Bad format'
    }
    
    angular.module('SpidApp').factory(meta.modelName, [function () {
        return function (params) {
            params = params || {}
            
            var self = this
            
            meta.attributes.forEach(function (attribute) {
                self[attribute] = params[attribute]
            })
        }
    }])
})

var metaServices = [
      { baseRoute: 'affranchissement'                               , modelName: 'Affranchissement'                             }
    , { baseRoute: 'choix_option_affranchissement_destination'      , modelName: 'ChoixOptionAffranchissementDestination'       }
    , { baseRoute: 'complement_service_affranchissement_destination', modelName: 'ComplementServiceAffranchissementDestination' }
    , { baseRoute: 'destination'                                    , modelName: 'Destination'                                  }
    , { baseRoute: 'destination_zone'                               , modelName: 'DestinationZone'                              }
    , { baseRoute: 'option_affranchissement_destination'            , modelName: 'OptionAffranchissementDestination'            }
    , { baseRoute: 'prix_service_affranchissement_destination'      , modelName: 'PrixServiceAffranchissementDestination'       }
    , { baseRoute: 'prix_tranche_affranchissement_zone'             , modelName: 'PrixTrancheAffranchissementZone'              }
    , { baseRoute: 'restriction'                                    , modelName: 'Restriction'                                  }
    , { baseRoute: 'service_affranchissement_destination'           , modelName: 'ServiceAffranchissementDestination'           }
    , { baseRoute: 'zone_affranchissement'                          , modelName: 'ZoneAffranchissement'                         }
]

metaServices.forEach(function (meta) {
    if (  !meta || !meta.modelName || !meta.baseRoute) {
        throw 'Bad format'
    }
    
    angular.module('SpidApp').factory(meta.modelName + 'Service', ['ServiceFactory', function (ServiceFactory) {
        return ServiceFactory(meta)
    }])
});

// delete metaModels;
// delete metaServices;